export const LINEITEMS = "lineItems";
export const PRICE_LIST_ITEM = "priceListItem";
export const QUANTITY = "quantity";
export const FORMATTED_PRICE = "formattedPrice";
export const COST = "cost";
export const WARD = "ward";
export const INPATIENT_NUMBER = "inpatientNumber";
export const ADMISSION_DATE = "admission";
export const DISCHARGE_DATE = "discharge";
export const PATIENT_TYPE = "patientType";
export const OUTPATIENT = "Outpatient";
export const INPATIENT = "Inpatient";
export const INPATIENT_DETAILS = "inpatientDetails";
export const DISABLED = "disabled";
export const REVENUE_DEPARTMENT = "revenueDepartment";
export const PRICE_TARIFF = "activeTariffId";
export const SUPPLIER = "supplier";
